import MaterialGrid from "../../../../__snowpack__/pkg/@mui/material/Grid.js";
import styled from "styled-components";
export const MergeHistoryGridContainer = styled(MaterialGrid).withConfig({
  displayName: "merge-history-cardstyles__MergeHistoryGridContainer",
  componentId: "sc-1m0m948-0"
})([".MuiPaper-root{", "}"], {
  height: "100%"
});
export const MergeHistoryCardContainer = styled.div.withConfig({
  displayName: "merge-history-cardstyles__MergeHistoryCardContainer",
  componentId: "sc-1m0m948-1"
})(["", ""], {
  display: "flex",
  flexDirection: "column",
  padding: "0.5rem"
});
